module.exports = __webpack_public_path__ + "media/application/images/icons/2-white-2a4c79a7f239d53297a0a6e7d0a0b2e0.svg";